import { toast } from "sonner";
import { virtualClassroomsApi } from "@/features/education-catalog/services/virtual-classrooms.api";

/**
 * Sınıf mailinin alıcılarını toplar: kursiyerler, istenirse kursiyerlerin Daire
 * Başkanı / İşletme Müdürü ve istenirse Eğitim Sorumluları.
 *
 * Yönetici ve sorumlular backend'de katılımcıların kök birimlerinden çözülür.
 * Bu sorgular patlarsa kursiyer listesiyle devam edilir — mail ekranını
 * açmamak için sebep değil.
 */
export async function collectClassroomMailRecipients(params: {
  virtualClassroomId?: string;
  traineeIds: string[];
  includeSupervisors: boolean;
  includeManagers: boolean;
}): Promise<string[]> {
  const { virtualClassroomId, traineeIds, includeSupervisors, includeManagers } = params;
  const ids = new Set(traineeIds);
  if (!virtualClassroomId) return [...ids];

  if (includeManagers) {
    try {
      const managers = await virtualClassroomsApi.listManagerRecipients(virtualClassroomId);
      if (managers.length === 0) {
        toast.warning(
          "Kursiyerlerin bağlı olduğu birimlerde tanımlı Daire Başkanı / İşletme Müdürü bulunamadı.",
        );
      }
      managers.forEach((m) => ids.add(m.id));
    } catch {
      // apiClient global toast; kursiyer listesiyle devam
    }
  }

  if (includeSupervisors) {
    try {
      const supervisors = await virtualClassroomsApi.listSupervisorRecipients(virtualClassroomId);
      if (supervisors.length === 0) {
        // Sessiz boş liste, "işaretledim ama gelmedi" şikâyetinin kaynağıydı.
        toast.warning(
          "Kursiyerlerin bağlı olduğu başkanlıklarda tanımlı Eğitim Sorumlusu bulunamadı.",
        );
      }
      supervisors.forEach((s) => ids.add(s.id));
    } catch {
      // apiClient global toast; devam
    }
  }
  return [...ids];
}

/** Mail ekranının URL'i: alıcılar dolu, sınıf verilirse kursiyer listesi PDF'i ekli açılır. */
export function buildClassroomMailUrl(recipientIds: string[], virtualClassroomId?: string): string {
  const params = new URLSearchParams();
  params.set("autoOpen", "1");
  params.set("target", "staff");
  params.set("prefillStaffIds", recipientIds.join(","));
  if (virtualClassroomId) params.set("prefillClassroomId", virtualClassroomId);
  return `/dashboard/mail-broadcast?${params.toString()}`;
}
